import {CleanlinessTypeEnum} from '@/models/digital-document-queue-sender-transfer-protocol-form-model';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function cleanlinessTypeNameFilter(type: CleanlinessTypeEnum): string {
  switch (type) {
    case CleanlinessTypeEnum.Clean: return i18n.t(LF.Clean) as string;
    case CleanlinessTypeEnum.Dirty: return i18n.t(LF.Dirty) as string;
    default: return ''
  }
}
